<style lang="scss" scoped="">
  @import "../../assets/scss/mixins";

  .content-part {
    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
      padding-left: 25px;
      padding-right: 25px;
    }
  }

  .batch-info {
    .oms-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right content-padding">
        <h3>库存详情</h3>
        <el-row class="batch-info">
          <el-col :span="12">
            <oms-row label="货主" :span="span">{{ currentItem.orgName }}</oms-row>
            <oms-row label="货品" :span="span">{{currentItem.goodsName }}</oms-row>
            <oms-row label="规格" :span="span">{{currentItem.specification }}</oms-row>
            <oms-row label="生产厂商" :span="span">{{ currentItem.factoryName }}</oms-row>
            <oms-row label="供货单位" :span="span">{{ currentItem.supplyManufacturersName }}</oms-row>
            <oms-row label="批号" :span="span">{{ currentItem.batchNumber }}</oms-row>
            <oms-row label="有效期" :span="span">{{ currentItem.expiryDate | date }}</oms-row>
            <template v-if="!isBatchNumber">
              <oms-row label="物流中心" :span="span">{{ currentItem.logisticsCentreName}}</oms-row>
              <oms-row label="单价" :span="span">¥ {{ currentItem.unitPrice | formatMoney }}</oms-row>
              <oms-row label="创建时间" :span="span">{{ currentItem.createTime | time }}</oms-row>
            </template>
          </el-col>
          <el-col :span="12">
            <oms-row label="合格业务库存" :span="span">{{ currentItem.availableCount }}</oms-row>
            <oms-row label="不合格业务库存" :span="span">{{ currentItem.unqualifiedBizCount }}</oms-row>
            <oms-row label="业务停销" :span="span">{{ currentItem.undeterminedCount }}</oms-row>
            <oms-row label="合格实物库存" :span="span">{{ currentItem.qualifiedCount }}</oms-row>
            <oms-row label="不合格实物库存" :span="span">{{ currentItem.unqualifiedCount }}</oms-row>
            <oms-row label="在途库存" :span="span">{{ currentItem.transitCount }}</oms-row>
            <oms-row label="库存总数" :span="span">{{ currentItem.totalCount }}</oms-row>
          </el-col>
        </el-row>
        <template v-if="isBatchNumber">
          <hr class="hr"/>
          <h2 style="padding-left: 0">批次库存</h2>
          <order-goods-list :data="list" v-loading="loading"/>
        </template>
        <template v-if="!isBatchNumber">
          <hr class="hr"/>
          <h2 style="padding-left: 0">对账明细</h2>
          <bill-list :id="currentItem && currentItem.id||''"/>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import {BspStock} from '@/resources';
  import OrderGoodsList from './order-goods-list';
  import billList from './bill-list';

  export default {
    props: ['currentItem', 'isBatchNumber', 'isPlatForm'],
    components: {OrderGoodsList, billList},
    data() {
      return {
        span: 9,
        list: [],
        loading: false
      };
    },
    watch: {
      currentItem(val) {
        if (!val || !val.id) return;
        if (!this.isBatchNumber) return;
        this.queryStockDetail(this.currentItem.id);
      }
    },
    methods: {
      queryStockDetail(id) {
        this.loading = true;
        BspStock.queryStockDetail(id).then(res => {
          this.list = res.data;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }
    }
  };
</script>
